export default (config) => ({
    autoPlay      : config.autoPlay ?? false,
    loop          : config.loop ?? false,
    interval      : config.interval ?? 5000,
    slidesSelector: config.slidesSelector,

    // Estado interno
    currentIndex: 0,
    slides: [],
    timer: null,

    initCarousel() {
        this.currentIndex = 0;
        // Una vez montado, buscamos todos los slides
        this.$nextTick(() => {
            this.slides = Array.from(this.$el.querySelectorAll(this.slidesSelector));

            // Si está habilitado el autoPlay, arrancamos
            if (this.autoPlay) {
                this.startAutoPlay();
            }

            this.updateTransform();
        });
    },

    startAutoPlay() {
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.nextSlide();
        }, this.interval);
    },

    nextSlide() {
        if (this.currentIndex < this.slides.length - 1) {
            this.currentIndex++;
        } else if (this.loop) {
            this.currentIndex = 0;
        }
        this.updateTransform();
    },

    prevSlide() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        } else if (this.loop) {
            this.currentIndex = this.slides.length - 1;
        }
        this.updateTransform();
    },

    goToSlide(index) {
        this.currentIndex = index;
        this.updateTransform();
    },

    // Actualiza el translateX para mostrar el slide actual
    updateTransform() {
        if (this.$refs.track) {
            this.$refs.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        }
    },
});
